import { GridPosition } from '~/types/drill'

export function getGridPosition(index: number): GridPosition {
  let colPosition = [0, 0]
  let rowPosition = [0, 0]

  switch (index) {
    case 0:
      colPosition = [1, 3]
      rowPosition = [1, 3]
      break

    case 1:
      colPosition = [2, 4]
      rowPosition = [3, 5]
      break

    case 2:
      colPosition = [3, 5]
      rowPosition = [5, 7]
      break

    case 3:
      colPosition = [5, 7]
      rowPosition = [5, 7]
      break

    case 4:
      colPosition = [6, 8]
      rowPosition = [3, 5]
      break

    case 5:
      colPosition = [8, 10]
      rowPosition = [3, 5]
      break

    default:
      break
  }

  return {
    gridColumnStart: colPosition[0],
    gridColumnEnd: colPosition[1],
    gridRowStart: rowPosition[0],
    gridRowEnd: rowPosition[1],
  }
}
